import React, { useContext, useRef } from 'react'
import { IdentityContext } from '#src/containers/Identity'
import { generateReferAFriendUrl } from '#src/services/referrals'
import { AnalyticsContext } from '#src/containers/Analytics'
import { NavItemBrowse, NavItemJournal, NavItem } from '../../Desktop/TopLevelNavItem'
import { useExperiment } from '@deal/experiment-js'
import NavItemMenuOption from '../TopLevelNavItemMenuOption'
import ArrowIcon from '../../../icons/arrow.svg'
import styles from './styles.css'
import useOnScreenCallback from '#src/hooks/useOnScreenCallback'

const Global: React.FC = () => {
  const { myself } = useContext(IdentityContext)
  const analytics = useContext(AnalyticsContext)
  const { result: journalExperimentResult } = useExperiment({
    experiment: 'desktop-journal-navigation',
    defaultTreatment: 'off'
  })
  const referralEntryPointRef = useRef(null)

  useOnScreenCallback(referralEntryPointRef, () => {
    myself?.user.isAllowedToRefer &&
      analytics?.events.trackReferralPageEntryPointViewed({
        entry_point: 'nav-bar'
      })
  })

  return (
    <ul className={styles.navList}>
      <NavItemBrowse>
        <span className={styles.navItemLabel}>Browse</span>
        <ArrowIcon className={styles.arrowIcon} />
      </NavItemBrowse>

      {/* v2 has no dropdown menu so we don't want to show the arrow */}
      {(journalExperimentResult === 'v1' || journalExperimentResult === 'v2') && (
        <NavItemJournal>
          <span className={styles.navItemLabel}>Expert Journal</span>
          {journalExperimentResult === 'v1' && <ArrowIcon className={styles.arrowIcon} />}
        </NavItemJournal>
      )}

      <NavItem
        to="/reviews"
        testId="desktop-reviews"
        menuOptions={
          <>
            <NavItemMenuOption to="/reviews">
              <span>Reviews</span>
            </NavItemMenuOption>
            <NavItemMenuOption to="/meet-the-experts">
              <span>Meet the Experts</span>
            </NavItemMenuOption>
            <NavItemMenuOption to="/support/faq">
              <span>FAQ</span>
            </NavItemMenuOption>
          </>
        }
        menuPosition="left"
      >
        <span className={styles.navItemLabel}>Reviews</span>
        <ArrowIcon className={styles.arrowIcon} />
      </NavItem>

      {myself?.user.isAllowedToRefer && (
        <NavItem to={generateReferAFriendUrl({ source: 'nav-bar' })} testId="desktop-referrals">
          <span ref={referralEntryPointRef} className={styles.navItemLabel}>
            Get 10% off
          </span>
        </NavItem>
      )}
    </ul>
  )
}

export default Global
